













import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class PopupDialog extends Vue {
  @Prop({ required: false })
  configStyle!: string;
  @Prop({ default: "pa-5" })
  cardStyle!: string;

  dialog = false;

  show(): void {
    setTimeout(() => {
      this.dialog = true;
      this.$emit("hasShown");
    }, 500);
  }

  close(): void {
    this.dialog = false;
    this.$emit("close");
  }
}
